import { Suspense, type PropsWithChildren } from "react";
import BonusXLoading from "./BonusXLoading";

function SuspenseWrapper({ children }: PropsWithChildren<unknown>) {
  return <Suspense fallback={<BonusXLoading />}>{children}</Suspense>;
}

export default SuspenseWrapper;
